module.exports = __webpack_public_path__ + "static/media/icon-mail.4229ea13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/landpage/icon-mail.svg
// module id = 305
// module chunks = 0